/* ------------------------------------------------------------------ */
/*  Platform-agnostic interaction toast types                          */
/*  Shared by web and mobile presentation layers.                      */
/* ------------------------------------------------------------------ */

export type InteractionToastType = 'warning' | 'reward' | 'guest_claim' | 'weekly_capped';

export interface InteractionToastData {
  type: InteractionToastType;
  title: string;
  duration: number;
  onClick?: () => void;
}

export interface FraudToastActions {
  showWarning: (title: string, duration?: number) => void;
  dismiss: () => void;
}

export interface RewardToastActions {
  showReward: (amount: string) => void;
  showGuestClaim: (onClick?: () => void) => void;
  showWeeklyCapped: () => void;
}
